module.exports = __webpack_public_path__ + "img/Flag_of_Australia.e60b8f24.svg";